import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { useHandleDeleteWorkspace } from "components/workspaces/hooks/handleDeleteWorkspace";
import { useGetCurrentWorkspace } from "components/workspaces/hooks/handleWorkspacePreferences";
import { globalWorkspaceSelector } from "components/workspaces/insWorkspaceLeftPane";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsDeleteWorkspaceDialogAction = () => {
    const dispatch = useDispatch();
    const { handleDeleteWorkspace } = useHandleDeleteWorkspace();
    const { currentWorkspace: workspace, workspacesAndPreferences: options } = useSelector((state) => globalWorkspaceSelector(state));
    const currentWorkspace = useGetCurrentWorkspace(workspace, options);
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                handleDeleteWorkspace(currentWorkspace?.id || "", options);
                dispatch(closeDialog());
            } }),
        React.createElement(CloseDialogButton, null));
};
